import styled, { CSSProperties, css } from 'styled-components'
import { Orientation } from './types'
import { OVERLAYS_Z_INDEX } from './constants'

type ContainerProps = {
  /**
   * Hide the inspector when the camera is moving
   * We don't want to cause frame drops when the camera is moving by re-rendering React components.
   * We use css instead of unmounting the whole component because of a bug in Safari.
   * https://github.com/sketch-hq/Cloud/issues/17971
   */
  $isHidden: boolean
}
export const Container = styled.div<ContainerProps>`
  ${({ $isHidden }) => $isHidden && 'display: none;'}
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

type LayerOverlayProps = {
  $width: number
  $height: number
  $x: number
  $y: number
  $borderSize: number
  $color: 'red' | 'blue' | 'purple'
  $zIndex?: number
  $hidden?: boolean
}

export const LayerOverlay = styled.div.attrs(
  ({ $x, $y, $width, $height, $hidden }: LayerOverlayProps) => {
    const style: CSSProperties = {
      transform: `translate(${$x}px, ${$y}px)`,
      width: `${$width}px`,
      height: `${$height}px`,
    }

    if ($hidden) {
      style.display = 'none'
    }

    return { style }
  }
)<LayerOverlayProps>`
  position: absolute;
  ${({ $borderSize, $color, theme }) => {
    let color = ''
    if ($color === 'red') {
      color = 'red'
    } else if ($color === 'blue') {
      color = 'rgb(5, 143, 255)'
    } else if ($color === 'purple') {
      color = theme.colors.inspect.symbol.A
    }

    return css`
      border-width: ${$borderSize}px;
      border-color: ${color};
      border-style: solid;
    `
  }}

  ${({ $zIndex }) => $zIndex && `z-index: ${$zIndex};`}
`

type MeasurementLineProps = {
  $orientation: Orientation
  $x: number
  $y: number
  $lineSize: number
}

export const MeasurementLine = styled.div.attrs(
  ({ $x, $y, $orientation, $lineSize }: MeasurementLineProps) => {
    const style: CSSProperties = {
      transform: `translate(${$x}px, ${$y}px)`,
      width: $orientation === Orientation.Horizontal ? `${$lineSize}px` : '1px',
      height:
        $orientation === Orientation.Horizontal ? '1px' : `${$lineSize}px`,
    }
    return { style }
  }
)<MeasurementLineProps>`
  z-index: ${OVERLAYS_Z_INDEX.MEASUREMENT_LINE};
  position: absolute;
  background: rgb(5, 143, 255);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const MeasurementPill = styled.div<{
  $orientation: Orientation
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: 10px; /* stylelint-disable-line */
  padding: 3px 5px; /* stylelint-disable-line */
  border-radius: 6px;
  color: white;
  background: rgb(5, 143, 255);
  transform: ${({ $orientation }) =>
    $orientation === Orientation.Horizontal
      ? 'translateY(calc(-50% - 4px));'
      : 'translateX(calc(-50% - 4px));'};
`
